module.exports = __webpack_public_path__ + "static/media/pride.27bc9465.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/pride.mp4
// module id = 75
// module chunks = 0